/* eslint-disable no-shadow */
/* eslint-disable no-param-reassign */
import Maintenance from '@/services/maintenance';

const state = {
  onMaintenance: false,
  maintenanceMessage: '',
};

const getters = {
  onMaintenance: currentState => currentState.onMaintenance,
  maintenanceMessage: currentState => currentState.maintenanceMessage,
};

const actions = {
  getItsOnMaintenance: async ({ commit }) => {
    try {
      const onMaintenance = await Maintenance.checkIfItsOnMaintenance();

      commit('setOnMaintenance', onMaintenance.status);
      commit('setMaintenanceMessage', onMaintenance.msg);
    } catch (err) {
      console.error(err);
    }
  },
};

const mutations = {
  setOnMaintenance: (currentState, isOnMaintenance) => {
    currentState.onMaintenance = isOnMaintenance;
  },
  setMaintenanceMessage: (currentState, maintenanceMessage) => {
    currentState.maintenanceMessage = maintenanceMessage;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
